import { HOLIDAYS } from '../action-types/holidays-types';
import { axiosAction } from '../../utils/axiosAction';

const ENDPOINT = process.env.REACT_APP_ENDPOINT_HOLIDAYS_ENDPOINT;

export const getHolidays = country => async dispatch => {
  const endpoint = `${ENDPOINT}/${country}`;
  return axiosAction.get(endpoint, HOLIDAYS, dispatch);
};
